import * as React from 'react';

import { StyledResourceIcon } from './styles';
import { Api } from '../../../../typings/api';
import Utils from '../../../../utils';

interface ResourceIconProps {
	type: Api.AssetItemFileTypes;
	fileFormat: Api.AssetItemFileFormats;
	isProposal: boolean;
}

const getIconName = (type: Api.AssetItemFileTypes, fileFormat: Api.AssetItemFileFormats, isProposal: boolean): string => {
	if (isProposal) {
		return 'iconset_uprez_proposal-blue';
	}

	const isFileIcon = [
		Api.AssetItemFileFormats.DOCUMENT,
		Api.AssetItemFileFormats.PDF,
		Api.AssetItemFileFormats.PRESENTATION,
		Api.AssetItemFileFormats.SPREADSHEET,
		Api.AssetItemFileFormats.INDESIGN,
		Api.AssetItemFileFormats.ILLUSTRATOR,
		Api.AssetItemFileFormats.PHOTOSHOP,
	].includes(fileFormat);

	if (isFileIcon) {
		switch (fileFormat) {
			case Api.AssetItemFileFormats.DOCUMENT:
				return 'iconset_uprez_file-document-blue';
			case Api.AssetItemFileFormats.PDF:
				return 'iconset_uprez_file-pdf-blue';
			case Api.AssetItemFileFormats.PRESENTATION:
				return 'iconset_uprez_file-presentation-blue';
			case Api.AssetItemFileFormats.SPREADSHEET:
				return 'iconset_uprez_file-spreadsheet-blue';
			case Api.AssetItemFileFormats.INDESIGN:
				return 'iconset_uprez_file-indesign-blue';
			case Api.AssetItemFileFormats.ILLUSTRATOR:
				return 'iconset_uprez_file-illustrator-blue';
			case Api.AssetItemFileFormats.PHOTOSHOP:
				return 'iconset_uprez_file-photoshop-blue';
			default:
				return 'iconset_uprez_file-blue';
		}
	} else {
		switch (type) {
			case Api.AssetItemFileTypes.PUBLICATION:
				return 'iconset_uprez_publication-blue';
			case Api.AssetItemFileTypes.IMAGE:
				return 'iconset_uprez_image-blue';
			case Api.AssetItemFileTypes.MOVIE:
				return 'iconset_uprez_movie-blue';
			case Api.AssetItemFileTypes.COMPONENT:
				return 'iconset_uprez_component-blue';
			case Api.AssetItemFileTypes.EXTERNAL_LINK:
				return 'iconset_uprez_link-blue';
			default:
				return 'iconset_uprez_file-blue';
		}
	}
};

const ResourceIcon = ({ type, fileFormat, isProposal }: ResourceIconProps) => (
	<StyledResourceIcon>
		{Utils.getSvgIcon(getIconName(type, fileFormat, isProposal))}
	</StyledResourceIcon>
);

export default ResourceIcon;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/Table/ResourceIcon/index.tsx